import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useContact } from "@/context/ContactContext";
import { useLang } from "@/context/LangContext";
import ContactForm from "@/components/ContactForm";

export default function ContactModal() {
  const { open, setOpen, product } = useContact();
  const { t } = useLang();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="contact-modal"
        className="bg-[#112318] border border-white/12 rounded-none text-white max-w-lg"
      >
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-black uppercase tracking-tight">
            {t.contact.form.title}
          </DialogTitle>
          <DialogDescription className="text-white/55 text-sm font-light">
            {t.contact.sub}
          </DialogDescription>
        </DialogHeader>
        <ContactForm product={product} onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
